import AbstractFacebook from './AbstractFacebook';
import ReactPixel from 'react-facebook-pixel';
import EventNames from '../constants/EventNames';
import { FACEBOOK_PIXEL_ID, TESTING } from '../constants/config';

class Facebook extends AbstractFacebook {
  constructor() {
    super();
    ReactPixel.init(FACEBOOK_PIXEL_ID, {}, { debug: TESTING });
  }

  logEvent(name, properties) {
    if (!this.shouldLogEvent(name)) return;

    if (name === EventNames.VIEW_SCREEN) {
      ReactPixel.pageView();
    } else {
      const { eventID, ...restProperties } = properties;
      ReactPixel.fbq('track', this.transformEventName(name), restProperties, { eventID });
    }
  }
}

export default new Facebook();
